module.exports = __webpack_public_path__ + "img/card.1b5bd889.jpg";